import { createSlice } from '@reduxjs/toolkit';
import { loginUser, logoutUser, getUserByToken, getUserBySecretKey } from '../thunks/userAuthThunks.js';

const initialState = {
    user: {},
    token: '',
    error: '',
    loading: false,
    permissions: {},
    initialized: false,
};

const userSlice = createSlice({
    name: 'userAuth',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                const { user, token, permissions } = action.payload;
                state.user = user;
                state.token = token;
                state.permissions = permissions;
                state.loading = false;
                state.error = '';
                state.initialized = true;
            })
            .addCase(getUserByToken.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(getUserByToken.fulfilled, (state, action) => {
                const { user, token, permissions } = action.payload;
                state.user = user;
                state.token = token;
                state.permissions = permissions;
                state.loading = false;
                state.error = '';
            })
            .addCase(getUserByToken.rejected, (state, action) => {
                state.user = {};
                state.token = '';
                state.permissions = {};
                state.loading = false;

                if (action.error?.message === 'Rejected') {
                    state.error = null;
                    return;
                }

                state.error = action.payload;
            })
            .addCase(getUserBySecretKey.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(getUserBySecretKey.fulfilled, (state, action) => {
                const { user, token, permissions } = action.payload;
                state.user = user;
                state.token = token;
                state.permissions = permissions;
                state.loading = false;
                state.error = '';
                state.initialized = true;
            })
            .addCase(getUserBySecretKey.rejected, (state) => {
                Object.assign(state, initialState);
                state.initialized = true;
            })
            .addCase(logoutUser.fulfilled, (state) => {
                Object.assign(state, initialState);
                state.initialized = true;
            })
            .addMatcher(
                (action) => [loginUser.rejected.type].includes(action.type),
                (state, action) => {
                    state.loading = false;
                    state.initialized = true;

                    if (action.error?.message === 'Rejected') {
                        state.error = null;
                        return;
                    }
                    state.error = action.payload || action.error?.message;
                },
            )
            .addMatcher(
                (action) =>
                    action.type.startsWith('userAuth/getUserBySecretKey') &&
                    (action.type.endsWith('/fulfilled') || action.type.endsWith('/rejected')),
                (state) => {
                    state.initialized = true;
                },
            )
            .addDefaultCase((state) => state);
    },
});

export default userSlice.reducer;
